module.exports = __webpack_public_path__ + "_app/img/uber.89e2f188.svg";